<div class="modal-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div
    class="modal-content"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tunnel-form-title"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header">
      <h2 class="modal-title" id="tunnel-form-title">{{ modalTitle }}</h2>
      <button
        type="button"
        class="close-button"
        (click)="onClose()"
        [disabled]="isSubmitting"
        aria-label="Close"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <form class="modal-form" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="form-field">
          <label class="field-label" for="tunnel-name"
            >Tunnel name <span class="required">*</span></label
          >
          <input
            id="tunnel-name"
            type="text"
            class="form-input"
            [class.error]="errors.name"
            [(ngModel)]="name"
            name="tunnelName"
            placeholder="e.g. Main tunnel"
            [attr.maxlength]="nameMaxLength"
            [disabled]="isSubmitting"
            autocomplete="off"
          />
          <div class="error-message" *ngIf="errors.name">{{ errors.name }}</div>
        </div>

        <div class="form-field">
          <label class="field-label" for="tunnel-serial"
            >Device serial number <span class="required">*</span></label
          >
          <input
            id="tunnel-serial"
            type="text"
            class="form-input"
            [class.error]="errors.serial"
            [(ngModel)]="serial"
            name="tunnelSerial"
            placeholder="e.g. E827252CF9B1"
            maxlength="32"
            [disabled]="isSubmitting"
            autocomplete="off"
          />
          <p class="helper-text">
            The Axis device the Tunnel Controller app is installed on (usually the tunnel entrance
            camera).
          </p>
          <div class="error-message" *ngIf="errors.serial">{{ errors.serial }}</div>
        </div>

        <fieldset class="form-field trigger-mode-field">
          <legend class="field-label">Start the wash <span class="required">*</span></legend>
          @for (option of triggerModeOptions; track option.value) {
            <label class="trigger-mode-option" [class.selected]="triggerMode === option.value">
              <input
                type="radio"
                name="triggerMode"
                [value]="option.value"
                [(ngModel)]="triggerMode"
                [disabled]="isSubmitting"
              />
              <span>{{ option.label }}</span>
            </label>
          }
        </fieldset>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="onClose()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button type="submit" class="btn-save" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Saving…' : submitLabel }}
        </button>
      </div>
    </form>
  </div>
</div>
